/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Pump_OnInputs */

const vi_irrigation_devices_pump_on = /** @type {(inputs: Irrigation_Devices_Pump_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang bật`)
};

/**

* @param {Irrigation_Devices_Pump_OnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_pump_on = /** @type {((inputs?: Irrigation_Devices_Pump_OnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Pump_OnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_pump_on(inputs)
});